module.exports = __webpack_public_path__ + "img/va.e06e2790.svg";